<template>
  <LexmeaFullScreenDialog
    :open="open"
    transition="enter-from-left"
    logoSize="sm"
    :headerBorderBottom="true"
    sticky
    @close="$emit('close')"
  >
    <div class="mx-5">
      <div class="mb-5">
        <span class="text-lg font-bold">{{
          $t("legal_text.rightColumn.notes.title")
        }}</span
        ><br />
        <span
          v-if="legalTextParagraph && legalText"
          class="text-sm font-semibold italic"
        >
          {{ $t("legal_text.rightColumn.notes.to") }}
          {{ title }}
        </span>
      </div>
      <NoteEditor
        v-for="(note, index) in currentParagraphNotes"
        :key="index"
        class="mx-0 my-4 scroll-my-2"
        :active="Boolean(active && active.id === note.id)"
        :note="note"
        @click="setActive(note)"
      />

      <span
        v-if="currentParagraphNotes?.length === 0"
        class="text-sm italic accent-lexmea-blue-900"
        >{{ $t("legal_text.rightColumn.notes.add_new_note_by_clicking") }}</span
      >
    </div>
  </LexmeaFullScreenDialog>
</template>
<script setup lang="ts">
import type { IFieldOfLaw } from "~/models/IFieldOfLaw";
import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";
import type { ILegalText } from "~/models/ILegalText";

const NoteEditor = defineAsyncComponent(
  () => import("~/components/legaltextparagraph/note/NoteEditor.vue")
);

defineProps<{
  open: boolean;
  paragraphFol?: IFieldOfLaw;
  legalText: ILegalText | undefined;
  legalTextParagraph: ILegalTextParagraph | undefined;
}>();
defineEmits<{
  close: [];
}>();

const { active } = useFetchActiveEntry();
const { setActive } = useSetActiveEntry();

const { currentParagraphNotes } = useParagraphNotes();

const legalTextParagraph = computed(
  () => currentParagraphNotes?.value[0]?.legal_text_paragraph
);

const { title } = useFullParagraphTitle(legalTextParagraph);
</script>
